import { cn } from "@/lib/utils";
import { ComponentProps, forwardRef } from "react";
import { textInputVariants } from "./styling";
import { VariantProps } from "class-variance-authority";

interface TextInputProps extends Omit<ComponentProps<"input">, "width">, VariantProps<typeof textInputVariants> {}

export const TextInput = forwardRef<HTMLInputElement, TextInputProps>(
  ({ className, state, width, multiline, focused, ...props }, ref) => (
    <input {...props} ref={ref} className={cn(textInputVariants({ state, width, multiline, focused }), className)} />
  ),
);

export const TransparentInput = forwardRef<HTMLInputElement, ComponentProps<"input">>(
  ({ className, ...props }, ref) => (
    <input
      {...props}
      ref={ref}
      className={cn("all-unset font-family-inherit border-0 bg-transparent", className)}
    />
  ),
);
